module.exports = __webpack_public_path__ + "images/lexus_smalldcd2dc8c77354109ee7ffb975fa9cdab.png";